import { render } from "./InvoiceListWidget.vue?vue&type=template&id=2b278c94&scoped=true&ts=true"
import script from "./InvoiceListWidget.vue?vue&type=script&lang=ts"
export * from "./InvoiceListWidget.vue?vue&type=script&lang=ts"

import "./InvoiceListWidget.vue?vue&type=style&index=0&id=2b278c94&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b278c94"]])

export default __exports__